<div class="um">
	<!-- ----- En-tête -->
	<div class="um__head">
		<span class="shell-avatar um__head-avatar">{{ userInitials() }}</span>
		<span class="um__head-text">
			<span class="um__head-name">{{ displayName() }}</span>
			@if (subtitle()) {
			<span class="um__head-sub">{{ subtitle() }}</span>
			}
		</span>
		@if (hasCotisation()) {
		<span class="um__role" [class.um__role--member]="isMember()">
			@if (isMember()) { {{ Dic.member.text }} } @else { {{ Dic.nomember.text }} }
		</span>
		}
	</div>

	<!-- ----- Accès rapides -->
	@if (ready()) {
	<div class="um__quick">
		<button class="um__tile" data-dict-key="myprofile" (click)="openModule('myap-myprofile')">
			<lucide-icon [img]="icons.LucideUser" [size]="16" />
			<span>{{ Dic.myprofile.text }}</span>
		</button>
		<button class="um__tile" data-dict-key="password" (click)="openModule('myap-mypassword')">
			<lucide-icon [img]="icons.LucideKey" [size]="16" />
			<span>{{ Dic.password.text }}</span>
		</button>
	</div>
	}

	<!-- ----- Compte -->
	@if (accountRows().length) {
	<div class="um__group">
		@for (row of accountRows(); track $index) {
		<ng-container *ngTemplateOutlet="umRow; context: { $implicit: row }" />
		}
	</div>
	}

	<!-- ----- Mandants -->
	@if (mandants().length > 1) {
	<div class="um__group">
		<div class="um__sec" data-dict-key="mandants">{{ Dic.mandants.text }}</div>
		<button class="um__select" [class.um__select--open]="mandantListOpen()" (click)="toggleMandantList()">
			<span class="um__ico"><lucide-icon [img]="icons.LucideCuboid" [size]="14" /></span>
			<span class="um__select-name">{{ currentMandantLabel() }}</span>
			<i class="pi pi-angle-down um__select-chev"></i>
		</button>
		@if (mandantListOpen()) {
		<div class="um__list">
			@for (m of mandants(); track m.nomdt) {
			<button class="um__opt" [class.um__opt--active]="m.nomdt === currentNomdt()" (click)="changeMandant(m.noevt)">
				<span class="um__opt-name">{{ m.mdt }}</span>
				@if (m.nomdt === currentNomdt()) {
				<i class="pi pi-check um__opt-check"></i>
				}
			</button>
			}
		</div>
		}
	</div>
	}

	<!-- ----- Applications -->
	@if (apps().length) {
	<div class="um__group">
		<div class="um__sec" data-dict-key="applications">{{ Dic.applications.text }}</div>
		<div class="um__seg">
			@for (app of apps(); track app.key) {
			<button class="um__seg-btn" [class.um__seg-btn--active]="app.key === currentApp()" (click)="changeApp(app.key)">
				{{ app.display }}
			</button>
			}
		</div>
	</div>
	}

	<!-- ----- Langue -->
	@if (ready()) {
	<div class="um__group">
		<div class="um__sec" data-dict-key="language">{{ Dic.language.text }}</div>
		<div class="um__seg">
			<button
				class="um__seg-btn"
				[class.um__seg-btn--active]="language() === 'fr'"
				data-dict-key="french"
				(click)="setLanguage('fr')">
				{{ Dic.french.text }}
			</button>
			<button
				class="um__seg-btn"
				[class.um__seg-btn--active]="language() === 'en'"
				data-dict-key="english"
				(click)="setLanguage('en')">
				{{ Dic.english.text }}
			</button>
		</div>
	</div>
	}

	<!-- ----- Administration -->
	@if (adminRows().length) {
	<div class="um__group">
		<div class="um__sec" data-dict-key="administration">{{ Dic.administration.text }}</div>
		@for (row of adminRows(); track $index) {
		<ng-container *ngTemplateOutlet="umRow; context: { $implicit: row }" />
		}
	</div>
	}

	<!-- ----- Session -->
	@if (sessionRows().length) {
	<div class="um__group um__group--last">
		@for (row of sessionRows(); track $index) {
		<ng-container *ngTemplateOutlet="umRow; context: { $implicit: row }" />
		}
	</div>
	}

	<!-- ----- Version -->
	@if (devMode() && appVersion()) {
	<div class="um__foot">
		<i class="pi pi-info-circle"></i>
		<span>{{ appVersion() }}</span>
	</div>
	}
</div>

<!-- ----- Gabarit de ligne -->
<ng-template #umRow let-row>
	<button class="um__row" [class.um__row--danger]="row.danger" (click)="runRow(row)">
		<span class="um__ico">
			@if (isLucideIcon(row.icon)) {
			<lucide-icon [img]="row.icon" [size]="14" />
			} @else {
			<i [class]="row.icon"></i>
			}
		</span>
		<span class="um__label">{{ row.label }}</span>
		@if (row.badge) {
		<span class="um__badge">{{ row.badge }}</span>
		} @else {
		<i class="pi pi-angle-right um__chev"></i>
		}
	</button>
</ng-template>
